<ngx-skeleton-loader [theme]="config"></ngx-skeleton-loader>